import React from 'react';
import LayoutProvider from '../../../Contexts/LayoutProvider';
import LibModal from '../../../features/LibModal/LibModal';
import PageTitle from '../../../utils/PageTitle';
import ProductListBody from './Components/ProductListBody';
import ProductListBodyMobile from './Components/ProductListBodyMobile';
import ProductListHeader from './Components/ProductListHeader';
import AddProductModal from './Modals/AddProductModal';
import ProductSettingProvider, { useProductSetting } from './ProductSettingProvider';

function PageCont() {
    const { createProductModal, setCreateProductModal, products, productFilter } =
        useProductSetting();

    const searchValue = productFilter?.searchValue || '';
    const status = productFilter?.status || '';

    // filter products by searchValue
    const data =
        products
            ?.filter((item) => {
                if (searchValue?.length) {
                    return item?.applicationTitle
                        ?.toLowerCase()
                        .includes(searchValue?.toLowerCase());
                }
                return [];
            })
            ?.filter((item) => {
                if (status?.length) {
                    return item?.status === status;
                }
                return [];
            }) || products;

    return (
        <div className="products-setting inner_page_cont pb-40">
            <ProductListHeader />

            <LayoutProvider>
                <ProductListBody layout="default" data={data} />
                <ProductListBodyMobile layout={['md', 'sm', 'xs', 'xxs']} data={data} />
            </LayoutProvider>

            {createProductModal && (
                <LibModal title="Add Product" setOpen={setCreateProductModal}>
                    <AddProductModal setCreateProductModal={setCreateProductModal} />
                </LibModal>
            )}
        </div>
    );
}

function ProductListPage() {
    // set page title
    PageTitle(`Products`);

    return (
        <ProductSettingProvider>
            <PageCont />
        </ProductSettingProvider>
    );
}

export default ProductListPage;
